<template>
  <div class="product-details-content-register-module-basic">
    <div class="d-flex flex-column gap-4">
      <snow-input
        v-model="form.name"
        id="name"
        class="w-100"
        label="Nome do módulo"
        :errors="errors.name"
        :maxLength="240"
        required
      />
      <snow-input
        v-model="form.description"
        id="description"
        label="Descrição do módulo"
        :errors="errors.description"
        type="textarea"
        rows="5"
        :maxLength="255"
      />
      <action-dispatcher
        action="membersCategories/getAll"
        :parameters="{
          product_id: $route.params.id,
          limit: 500
        }"
      >
        <div class="categories-container">
          <snow-checkboxes-dropdown
            v-model="form.category_ids"
            class="w-100"
            :options="dropdownCategories"
            placeholder="Selecione as categorias"
          />
          <snow-button
            text="Adicionar categoria"
            icon="ph ph-plus"
            variant="gray"
            @click="openCategoryModal"
          />
        </div>
      </action-dispatcher>

      <div class="pt-4">
        <h5 class="text-semibold">
          Liberação do módulo
        </h5>
        <small class="text-dark-40 fs-12">
          Determine em quantos dias o seu conteúdo será liberado após a compra.
        </small>
      </div>
      <snow-switch
        id="_days_to_release"
        v-model="days_to_release"
        label="Liberar após quantidade de dias"
      />

      <div v-if="days_to_release">
        <snow-input
          v-model="form.days_to_release"
          :errors="errors.days_to_release"
          id="days_to_release"
          label="Liberar após"
          type="number"
        />
      </div>

      <snow-switch
        id="_release_at"
        v-model="release_at"
        label="Liberar em uma data específica"
      />

      <div v-if="release_at">
        <snow-date-picker
          v-if="release_at"
          v-model="form.release_at"
          :errors="errors.release_at"
          id="release_at"
          size="lg"
          isHours
          format="DD/MM/YYYY"
          label="Liberar no dia"
        />
      </div>
    </div>
    <responsive-modal v-model="openModal" title="Adicionar categoria">
      <category-modal @success="categoryOnSuccess" @close="openModal = false" />
    </responsive-modal>
  </div>
</template>
<script>
import get from "lodash/get";
import { mapState } from "vuex";
import CategoryModal from "./category/CategoryModal.vue";

export default {
  components: {
    CategoryModal
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    module: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const f = field => (get(this.module, field) || "").substr(0, 19);
    return {
      openModal: false,
      days_to_release: !!get(this.module, "days_to_release", 0),
      release_at: this.module.release_at && f("release_at") !== f("created_at")
    };
  },
  methods: {
    openCategoryModal() {
      this.openModal = true;
    },
    categoryOnSuccess(newCategory) {
      this.openModal = false;
      this.$store.commit("membersCategories/setCategories", [
        ...this.categories,
        newCategory
      ]);
      this.form.category_ids.push(newCategory.id);
    }
  },
  computed: {
    ...mapState("membersCategories", ["categories"]),
    dropdownCategories() {
      return this.categories.map(categorie => ({
        id: categorie.id,
        label: categorie.name
      }));
    }
  },
  watch: {
    days_to_release(v) {
      if (!v) {
        this.form.days_to_release = 0;
      } else {
        this.release_at = false;
      }
    },
    release_at(v) {
      if (!v) {
        this.form.release_at = null;
      } else {
        this.days_to_release = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .categories-container {
  display: flex;
  align-items: center;
  gap: 16px;

  @media screen and (max-width: 991px) {
    flex-direction: column;
    align-items: start;
  }
}
</style>
